<template>
  <div :id="thumbId"
       class="thumbnail-container"
  >
    <img :src="thumbUrl"
         :class="{ 'floating': isFloating && !isSelected, 'selected': isSelected, disabled: disabled }"
         :style="thumbnailStyle"
         @click="$emit('click', thumbId)"
    />
  </div>

  <DxTooltip :target="`#${thumbId}`"
             container="body"
             :showEvent="disabled ? '' : 'mouseenter'"
             :hideEvent="disabled ? '' : 'mouseleave'"
             position="right"
             :animation="null"
             v-show="!disabled"
  >
    <template #content>
      <img class="exploded-thumbnail" :src="thumbUrl" :style="thumbnailStyle" />
    </template>
  </DxTooltip>
</template>

<script setup>
  import { DxTooltip } from 'devextreme-vue/tooltip'
  import { computed } from 'vue'

  const props = defineProps(['thumbId', 'thumbUrl', 'isSelected', 'isFloating', 'disabled', 'rotationDegrees'])
  const emit = defineEmits(['click'])

  const thumbId = computed(() => `thumb-${props.thumbId}${props.disabled}`)
  const thumbnailStyle = computed(() => {
    const floatingTransform = props.isFloating && !props.isSelected ? 'translate(-2px, -2px) ' : ''
    return { transform: `${floatingTransform}rotate(${props.rotationDegrees || 0}deg)` }
  })
</script>

<style scoped lang="scss">
  .thumbnail-container {
    width: 85px;
    cursor: pointer;

    img {
      border: 1px solid $la-new-dark-gray;
      max-width: 85px;
      max-height: 110px;
    }

    img.selected {
      border: 2px solid $la-accent;
    }
  }

  .thumbnail-container.disabled {
    cursor: default;
  }

  .exploded-thumbnail {
    max-height: 100vh;
    max-width: 100vw;
  }

  .floating {
    transform: translate(-2px, -2px);
    box-shadow: $la-new-dark-gray 2px 2px;
  }
</style>
